import "./services-details.css";
import { FaLightbulb, FaPencilRuler, FaCode, FaRocket } from "react-icons/fa";

const ServicesDetails = () => {
  return (
    <section className="services-details">
      <div className="services-details__container">
        {/* HEADER */}
        <div className="services-details__header">
          <span className="services-details__badge">How We Work</span>

          <h2 className="services-details__title">
            From <span>Idea</span> to Scalable Digital Product
          </h2>

          <p className="services-details__subtitle">
            Our proven process ensures clarity, speed, and quality at every
            stage — delivering digital solutions built to scale.
          </p>
        </div>

        {/* PROCESS */}
        <div className="services-details__grid">
          <div className="services-details__card">
            <div className="services-details__icon">
              <FaLightbulb />
            </div>
            <h3>Discovery & Strategy</h3>
            <p>
              We analyze your business goals, target users, and technical
              requirements to create a clear, actionable roadmap.
            </p>
          </div>

          <div className="services-details__card">
            <div className="services-details__icon">
              <FaPencilRuler />
            </div>
            <h3>Design & Architecture</h3>
            <p>
              Our team designs intuitive user experiences and robust system
              architectures focused on scalability and performance.
            </p>
          </div>

          <div className="services-details__card">
            <div className="services-details__icon">
              <FaCode />
            </div>
            <h3>Development & Testing</h3>
            <p>
              We build secure, high-performance applications using modern
              technologies with continuous testing and quality checks.
            </p>
          </div>

          <div className="services-details__card">
            <div className="services-details__icon">
              <FaRocket />
            </div>
            <h3>Launch & Growth</h3>
            <p>
              After deployment, we provide optimization, monitoring, and ongoing
              support to help your product grow and evolve.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesDetails;
